<template>
  <div :class="fixPosition ? 'input-check fix-position' : 'input-check'">
    <input 
      type="checkbox" 
      :id="id" 
      :value="v" 
      v-model="selectedValue" 
      :disabled="disabled" 
      @change="($event) => { $emit('change', $event) }" 
      @click.stop="$emit('click')"
    />
    <label
      v-if="label"
      :for="id"
      :style="`font-weight: ${labelFontWeight}; font-size: ${labelFontSize}; padding-left: 4px`"
      @click.stop="$emit('click')"
    >
      <span :style="disabled ? 'color:#ABABAB': ''">{{label}}</span>
      <span v-if="description" :style="disabled ? 'color:#ABABAB': ''" class="desc">{{description}}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'CheckBoxV2',
  props: {
    value: {required: true},
    v: {required: false, default: () => true},
    id: {required: true},
    label: {type: String},
    disabled: {type: Boolean, default: false},
    labelFontWeight: {type: String, default: '400'},
    labelFontSize: {type: String, default: '0.9rem'},
    description: {type: String},
    fixPosition: {type: Boolean, default: false}
  },
  computed: {
    selectedValue: {
      get () {
        return this.value
      },
      set (v) {
        return this.$emit('input', v)
      }
    }
  }
}
</script>

<style scoped>
  .input-check {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    height: 24px;
    /* cursor: pointer; */
    -webkit-touch-callout: none;  /* iPhone OS, Safari */
    -webkit-user-select: none;    /* Chrome, Safari 3 */
    -khtml-user-select: none;     /* Safari 2 */
    -moz-user-select: none;       /* Firefox */
    -ms-user-select: none;        /* IE10+ */
    user-select: none;
  }

  .input-check /deep/ label {
    cursor: pointer;
  }

  .desc {
    display: block !important;
    font-size: 13px !important;
    font-weight: 400 !important;
    line-height: 11px !important;
    color: #909091 !important;
  }

  .input-check input[type='checkbox'] {
    -moz-appearance: none;
    -webkit-appearance: none;
    -o-appearance: none;
    height: 24px;
    width: 24px;
    cursor: pointer;
  }

  .input-check input[type='checkbox']::before {
    content: '';
    position: absolute;
    height: 24px;
    width: 24px;
    background-color: white;
    border-radius: 8px;
    border: 1px solid #dadde1;
  }

  .input-check input[type='checkbox']:checked::before {
    content: '';
    display: block;
    position: absolute;
    text-align: center;
    height: 24px;
    width: 24px;
    background-color: #192B46;
    border-radius: 8px;
    border: 1px solid #192B46;
  }

  .input-check input[type='checkbox']:checked::after {
    content: url('./img/check.svg');
    display: block;
    position: absolute;
    top: 0px;
    left: 7px;
  }

  .fix-position input[type='checkbox']:checked::after {
    content: url('./img/check.svg');
    display: block;
    position: absolute;
    top: 3px;
    left: 7px;
  }

  /* Disabled  */
  .input-check input[type='checkbox']:disabled {
    cursor: default;
  }

  .input-check input[type='checkbox']:disabled::before {
    background-color: #ccc;
    border: 1px solid #ccc;
  }
</style>
